"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Separator = exports.Container = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Utils = require("../Utils");
var _templateObject, _templateObject2;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
const Container = exports.Container = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    align-items: center;\n    border: 1px solid ", ";\n    border-radius: 4px;\n    display: flex;\n    height: ", "px;\n    justify-content: center;\n    ", "\n    padding: 0px 5px;\n    position: relative;\n    ", "\n"])), _ref => {
  let {
    error,
    theme: {
      dangerColor,
      primaryColor
    }
  } = _ref;
  return error ? dangerColor : primaryColor;
}, (0, _Utils.getProp)('height'), (0, _Utils.parseProp)('margin'), (0, _Utils.parseProp)('width'));
const Separator = exports.Separator = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    color: ", ";\n    font-size: 12px;\n    margin: 0px 5px;\n"])), _ref2 => {
  let {
    error,
    theme: {
      dangerColor,
      primaryColor
    }
  } = _ref2;
  return error ? dangerColor : primaryColor;
});